import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'

import ViewShippingDetail from '../../Containers/Ecommerce/ViewShippingDetail'
import EcommerceOrderActions from '../../Redux/EcommerceOrderRedux'

class ManageEcommerceOrder extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.state = {
      showModal: null,
      detail: {},
      filter: {
        page: 1,
        limit: 10
      }
    }
  }

  componentDidMount = () => {
    this._customFetch()
  }

  _customFetch = (filter = { page: 1 }, event) => {
    if (event) event.preventDefault()
    let params = {
      ...this.state.filter,
      ...filter
    }
    this.props.getEcommerceOrder(params)
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    this._customFetch({ page })
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._customFetch(this.state.filter.page)
    }
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  render () {
    const { ecommerceOrder } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Manage Ecommerce Order
              {
                (ecommerceOrder.fetching || ecommerceOrder.processing) &&
                <div className='badge badge-info ml-2'>Loading...</div>
              }
            </h3>
          </div>
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(ecommerceOrder.fetching || ecommerceOrder.processing) && ecommerceOrder.err &&
              <div className='alert alert-danger'>{ecommerceOrder.err}</div>
            }
            <table className='table table-hover table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>Order Number</th>
                  <th className='text-center'>Status</th>
                  <th className='text-center'>Customer Name</th>
                  <th className='text-center'>Phone Number</th>
                  <th className='text-center'>Email Address</th>
                  <th className='text-center'>Shipping Detail</th>
                </tr>
              </thead>
              <tbody>
                {
                  ecommerceOrder.data && (ecommerceOrder.data.data && ecommerceOrder.data.data.length)
                    ? ecommerceOrder.data.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{item.order_number}</td>
                        <td className='text-center'>{item.status}</td>
                        <td className='text-center'>
                          {item.salutation} { item.first_name } {item.last_name}
                        </td>
                        <td className='text-center'>{item.phone_number}</td>
                        <td className='text-center'>{item.email}</td>
                        <td className='text-center'>
                          <button
                            className='btn btn-info'
                            onClick={() => this._selectItem(item, 'view-shipping')}
                            disabled={item.status !== 'confirmed'}
                          >
                            <i className='fa fa-book' />
                          </button>
                        </td>
                      </tr>
                    ))
                    : <tr>
                      <td className='text-center' colSpan='6'>--No Data--</td>
                    </tr>
                }
              </tbody>
            </table>
          </div>
          <section className='text-center'>
            {
              (ecommerceOrder.data && ecommerceOrder.data.total > 10) &&
              <Pagination
                innerClass='pagination'
                itemClass='page-item'
                linkClass='page-link'
                activePage={ecommerceOrder.data.page || this.state.filter.page}
                itemsCountPerPage={10}
                totalItemsCount={ecommerceOrder.data.total}
                pageRangeDisplayed={5}
                onChange={this._changePage}
              />
            }
          </section>
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-shipping'} onClose={() => this._toggleModal()}>
            <ViewShippingDetail uuid={this.state.detail.id} closeModal={() => this._toggleModal()} />
          </Modal>
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  ecommerceOrder: state.ecommerceOrder
})

const dispatchToProps = (dispatch) => ({
  getEcommerceOrder: (filter) => dispatch(EcommerceOrderActions.getEcommerceOrderRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(ManageEcommerceOrder)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageEcommerceOrder.js